import React, { useState, useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import CookieConsent from './components/CookieConsent';
import categories from './data/categories.json';
import {
  HomePage,
  BlogPage,
  PostPage,
  PrivacyPolicy,
  CookiePolicy,
  TermsConditions,
  AboutUs,
  FontsIndexPage,
  ContactPage,
  UnicodeSymbolsPage,
  BackwardsTextPage,
  KaomojiPage,
  LennyFacesPage,
  ImageDotArtPage,
  AsciiArtPage,
  UsernamePage,
  NumberFontPage,
  TattooFontPage,
  CaseConverterPage,
  WordCounterPage,
  TextStylerPage,
  FontImageGeneratorPage,
  TextRepeaterPage,
  WingdingsTranslatorPage,
  MonogramMakerPage,
  FullscreenTextPage,
  UnicodeCompatibilityPage,
} from './lazyRoutes';

const App = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-[var(--color-bg)]">
        <Header toggleDarkMode={toggleDarkMode} isDarkMode={isDarkMode} categories={categories} />
        <main className="flex-1 py-3 md:py-4">
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<HomePage isDarkMode={isDarkMode} />} />
              <Route path="/underline-text" element={<Navigate to="/fonts/underline-text/" replace />} />
              <Route path="/backwards-text" element={<BackwardsTextPage />} />
              <Route path="/fonts/backwards-text" element={<Navigate to="/backwards-text/" replace />} />
              <Route path="/fonts/lenny-faces-fonts" element={<Navigate to="/fonts/" replace />} />
              <Route path="/fonts/small-caps" element={<Navigate to="/fonts/small-fonts/" replace />} />
              <Route path="/fonts/:categorySlug" element={<HomePage isDarkMode={isDarkMode} />} />
              <Route path="/fonts" element={<FontsIndexPage categories={categories} isDarkMode={isDarkMode} />} />
              <Route path="/blog" element={<BlogPage isDarkMode={isDarkMode} />} />
              <Route path="/blog/:id" element={<PostPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/AboutUs" element={<Navigate to="/about/" replace />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/unicode-symbols" element={<UnicodeSymbolsPage />} />
              <Route path="/kaomoji" element={<KaomojiPage />} />
              <Route path="/lenny-faces" element={<LennyFacesPage />} />
              <Route path="/dot-art-generator" element={<ImageDotArtPage />} />
              <Route path="/ascii-art-generator" element={<AsciiArtPage />} />
              <Route path="/username-generator" element={<UsernamePage isDarkMode={isDarkMode} />} />
              <Route path="/number-font-generator" element={<NumberFontPage isDarkMode={isDarkMode} />} />
              <Route path="/tattoo-font-generator" element={<TattooFontPage isDarkMode={isDarkMode} />} />
              <Route path="/case-converter" element={<CaseConverterPage isDarkMode={isDarkMode} />} />
              <Route path="/word-counter" element={<WordCounterPage isDarkMode={isDarkMode} />} />
              <Route path="/text-styler" element={<TextStylerPage isDarkMode={isDarkMode} />} />
              <Route path="/font-image-generator" element={<FontImageGeneratorPage />} />
              <Route path="/text-repeater" element={<TextRepeaterPage isDarkMode={isDarkMode} />} />
              <Route path="/wingdings-translator" element={<WingdingsTranslatorPage isDarkMode={isDarkMode} />} />
              <Route path="/monogram-maker" element={<MonogramMakerPage isDarkMode={isDarkMode} />} />
              <Route path="/fullscreen-text" element={<FullscreenTextPage isDarkMode={isDarkMode} />} />
              <Route path="/unicode-font-compatibility" element={<UnicodeCompatibilityPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <ScrollToTopButton />
        <CookieConsent />
      </div>
    </Router>
  );
};

export default App;
